import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Returns the invoice PDF for the caller's own order, base64 encoded. */
export const getInvoicePdf = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data) => z.object({ orderId: z.string().uuid() }).parse(data))
  .handler(async ({ data, context }) => {
    const { supabase, userId } = context as { supabase: any; userId: string };

    const { data: order, error } = await supabase
      .from("orders")
      .select("id,user_id")
      .eq("id", data.orderId)
      .maybeSingle();
    if (error || !order || order.user_id !== userId) throw new Error("Invoice not found.");

    const { loadInvoiceData, renderInvoicePdf, invoiceFileName } = await import(
      "./invoice-pdf.server"
    );
    const invoice = await loadInvoiceData(data.orderId);
    if (!invoice) throw new Error("Invoice not found.");

    const bytes = await renderInvoicePdf(invoice);
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);

    return {
      fileName: invoiceFileName(invoice.invoiceNumber),
      base64: btoa(binary),
    };
  });
